import Vue from "vue";
import Router from "vue-router";
import MemberLogin from "@/components/member_login";
import AdminLogin from "@/components/admin_login";
import MemberQueue from "@/components/member_queue";
import AdminDashboard from "@/components/admin_dashboard";
import DashboardOptions from "@/components/admin_dashboard_options";
import AddAssociation from "@/components/admin_add_association";
import MemberInfo from "@/components/admin_member_info";
import AssociationInfo from "@/components/admin_association_info";
import AddMember from "@/components/admin_add_member";
import EditMember from "@/components/admin_edit_member";
import EditAssociation from "@/components/admin_edit_association";
import AuthApi from "@/utils/api/auth";

Vue.use(Router);

var router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "member_login",
      component: MemberLogin,
      meta: {
        secure: false
      }
    },
    {
      path: "/queue",
      name: "member_queue",
      component: MemberQueue,
      meta: {
        secure: false
      }
    },
    {
      path: "/login",
      name: "admin_login",
      component: AdminLogin,
      meta: {
        secure: false
      }
    },
    {
      path: "/administration",
      name: "admin_dashboard",
      component: AdminDashboard,
      meta: {
        secure: true
      }
    },
    {
      path: "/administration/options",
      name: "options",
      component: DashboardOptions,
      meta: {
        secure: true
      }
    },
    {
      path: "/administration/members/create",
      name: "add_member",
      component: AddMember,
      meta: {
        secure: true
      }
    },
    {
      path: "/administration/members/:booknum/info",
      name: "member_info",
      component: MemberInfo,
      meta: {
        secure: true
      }
    },
    {
      path: "/administration/members/:booknum/edit",
      name: "edit_member",
      component: EditMember,
      meta: {
        secure: true
      }
    },
    {
      path: "/administration/associations/:association/create",
      name: "add_association",
      component: AddAssociation,
      meta: {
        secure: true
      }
    },
    {
      path: "/administration/associations/:association/:id/info",
      name: "association_info",
      component: AssociationInfo,
      meta: {
        secure: true
      }
    },
    {
      path: "/administration/associations/:association/:id/edit",
      name: "edit_association",
      component: EditAssociation,
      meta: {
        secure: true
      }
    }
  ]
});

router.beforeEach(async (to, from, next) => {
  // Checking if valid cookie exists, skips login if true
  if (to.fullPath === "/login") {
    var match = document.cookie.match(
      new RegExp("(^| )" + "iwl_apiToken" + "=([^;]+)")
    );
    if (match === null) {
      return next();
    }

    var authorized = await AuthApi.checkLoggedIn(
      document.cookie.match(match[2])
    );
    if (!authorized) {
      next();
    } else {
      next("/administration");
    }
    // Checking if valid cookie exists before going to secure page.
    // Redirects to login if false, continues if true.
  } else if (to.matched.some(record => record.meta.secure)) {
    var match = document.cookie.match(
      new RegExp("(^| )" + "iwl_apiToken" + "=([^;]+)")
    );

    if (match === null) {
      return next("/login");
    }
    var authorized = await AuthApi.checkLoggedIn(
      document.cookie.match(match[2])
    );
    if (!authorized) {
      next("/login");
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js